module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-polygon-container",
    style: (("width:" + (this.width) + ";height:" + (this.height) + ";"))
  }, [_c('div', {
    staticClass: "map-polygon",
    attrs: {
      "id": ("map-polygon" + (this._uid))
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44a6ff1f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/MapArea.vue
// module id = 709
// module chunks = 0